import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import styles from './FeedbackButton.module.css';

const FeedbackButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className={styles.feedbackButton}
        onClick={() => setIsModalOpen(true)}
        aria-label="Geri Bildirim"
      >
        <span className={styles.feedbackText}>Geri Bildirim</span>
      </button>
      {isModalOpen && (
        <FeedbackModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default FeedbackButton;
